package com.ilussobsa

import com.lightningkite.kiteui.views.RContext
import com.lightningkite.kiteui.views.RView
import com.lightningkite.kiteui.views.ViewDsl
import com.lightningkite.kiteui.views.ViewWriter
import kotlin.contracts.ExperimentalContracts
import kotlin.contracts.InvocationKind
import kotlin.contracts.contract


expect class AuctioneerView(context: RContext) : RView {
    var animationAction: AnimationAction
}

@OptIn(ExperimentalContracts::class)
@ViewDsl
inline fun ViewWriter.auctioneer(setup: AuctioneerView.() -> Unit = {}): AuctioneerView {
    contract { callsInPlace(setup, InvocationKind.EXACTLY_ONCE) }
    return write(AuctioneerView(context), setup)
}